import { Link as GatsbyLink } from "gatsby"
/** @jsx jsx */
import { jsx, Link } from "theme-ui"
import { useSiteMetadata } from '../hooks/use-site-metadata'

export default function Footer(props) {

  const { email } = useSiteMetadata().contact

  return (
    <footer {...props}
      sx={{
        textAlign: 'center',
        p: 3,
        '&, a': {
          color: 'disabled',
        },
      }}
    >
      Ce site est une initiative de l'association La Monniéroise - <Link as={GatsbyLink} to="/mentions-legales">Mentions légales</Link> - <Link href={`mailto:${email}`}>Contact</Link>
    </footer>
  )
}
